<template>
	<div>
		<ScheduleBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>사이즈 조건표</h3>
				<p>Easy China Size Chart<br>옷 사이즈를 쉽게 구분하세요.</p>
			</div>
			<h5 class="size-nation">중국 <span>China</span></h5>
			<article>
				<strong>남성 <span>Men</span></strong>
				<div class="size-items">
					<p>상의<img src="../../assets/icon/size-top.jpg" alt="상의"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>90(XS)</p>
								<span>158-162</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>95(S)</p>
								<span>163-167</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>100(M)</p>
								<span>168-172</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>105(L)</p>
								<span>173-177</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>110(XL)</p>
								<span>178-182</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>115(2XL)</p>
								<span>182-187</span>
							</div>
						</el-col>			
					</el-row>
				</div>
				<div class="size-items">
					<p>하의<img src="../../assets/icon/size-bottom.png" alt="하의"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>90(XS)</p>
								<span>
									170/72A<br>
									170/74A
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>95(S)</p>
								<span>
									170/76A<br>
									175/80A
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>100(M)</p>
								<span>
									175/82A<br>
									175/84A
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>105(L)</p>
								<span>
									180/86A<br>
									180/90A
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>110(XL)</p>
								<span>
									185/92A<br>
									185/94A
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>115(2XL)</p>
								<span>
									190/98B<br>
									195/102B
								</span>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="size-items">
					<p>신발<img src="../../assets/icon/size-shoes.png" alt="신발"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>단위 mm</p>
								<span>-</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>240</p>
								<span>38</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>245</p>
								<span>39</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>250</p>
								<span>40</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>255</p>
								<span>41</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>260</p>
								<span>42</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>265</p>
								<span>43</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>270</p>
								<span>44</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>275</p>
								<span>45</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>280</p>
								<span>46</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>285</p>
								<span>47</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>290</p>
								<span>48</span>
							</div>
						</el-col>
					</el-row>			
				</div>
		
			</article>
			<article>
				<strong>여성 <span>Women</span></strong>
				<div class="size-items">
					<p>상의<img src="../../assets/icon/size-top.jpg" alt="상의"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>90(XS)</p>
								<span>150/80A</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>95(S)</p>
								<span>155/82A</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>100(M)</p>
								<span>160/84A</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>105(L)</p>
								<span>165/86A</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>110(XL)</p>
								<span>170/88A</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>115(2XL)</p>
								<span>172/98A</span>
							</div>
						</el-col>			
					</el-row>
				</div>
				<div class="size-items">
					<p>하의<img src="../../assets/icon/size-bottom.png" alt="하의"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>90(XS)</p>
								<span>
									52/52.5
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>95(S)</p>
								<span>
									57/59.5
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>100(M)</p>
								<span>
									62/64.5
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>105(L)</p>
								<span>
									67/69.5
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>110(XL)</p>
								<span>
									77/79.5
								</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>115(2XL)</p>
								<span>
									82/84.5
								</span>
							</div>
						</el-col>
					</el-row>	
				</div>
				<div class="size-items">
					<p>신발<img src="../../assets/icon/size-shoes.png" alt="신발"></p>
					<el-row>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>단위 mm</p>
								<span>-</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>220</p>
								<span>34</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>225</p>
								<span>35</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>230</p>
								<span>36</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>235</p>
								<span>37</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>240</p>
								<span>38</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>245</p>
								<span>39</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>250</p>
								<span>40</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>255</p>
								<span>41</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>260</p>
								<span>42</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>265</p>
								<span>43</span>
							</div>
						</el-col>
						<el-col :xs="12" :sm="8" :md="4">
							<div class="size-item">
								<p>270</p>
								<span>44</span>
							</div>
						</el-col>
						
					</el-row>	
				</div>
			</article>
			
			<div class="common-wrap">
				<h6>공통사항</h6>
				<p>- 사이즈 기준은 한국(KR)입니다.</p>
				<p>- 브랜드, 핏(Fit)별로 사이즈가 상이하니 참고에 유의하세요.</p>
			</div>
			
		</div>
	</div>
</template>

<script>
	import ScheduleBanner from '../../components/ScheduleBanner.vue'
	export default {
		components: {
			ScheduleBanner
		},
		data() {
			return{ 
				  
			}
		},
	
		methods: {
	
		}
	
	}
</script>

<style scoped>
	.title-wrap {
	    margin-top: 37px;
	    margin-bottom: 97px;
		text-align: center;
		color: var(--frontground-color);
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.title-wrap p {
	    font-size: 24px;
	    color: var(--frontground-color);
	    line-height: 39px;
	    font-weight: 500;
	    margin-top: 12px;
	}
	.size-nation {
	    font-size: 24px;
	    font-weight: bold;
	    border-bottom: 1px solid #333;
	    padding-bottom: 40px;
	}
	.size-nation span {
	    color: var(--main-color);
	}
	article {
	    margin-top: 38px;
	}
	article > strong {
	    display: block;
	    font-size: 20px;
	    font-weight: bold;
	    margin-bottom: 17px;
	}
	article > strong span {
	    color: var(--main-color);
	}
	article .size-items {
	    text-align: center;
	    border: 1px solid #e8e8e8;
	    border-radius: 20px;
	    background-color: #fff;
		color: var(--background-color);
	    margin-bottom: 20px;
	    padding: 27px 29px 29px 29px;
	}
	article .size-items > p {
	    font-size: 20px;
	    font-weight: 600;
	    margin-bottom: 18px;
	}
	article .size-items > p img {
	    margin-left: 4px;
	}
	.size-item{
		border: 1px solid #e8e8e8;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 17px 0 14px;
		margin:0 5px 10px;
		height:110px;
	}
	.size-item p {
	    font-size: 17px;
	    font-weight: 500;
	    color: rgba(0, 0, 0, 0.8);
	    margin-bottom: 2px;
	}
	.size-item span {
	    font-size: 17px;
	    font-weight: 500;
	    color: var(--main-color);
	    line-height: 30px;
	}
	.common-wrap {
	    margin-top: 102px;
	}
	.common-wrap h6 {
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 19px;
	}
	.common-wrap p {
	    font-size: 17px;
	    color: var(--frontground-color);
	    margin-bottom: 5px;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:0 10px;
		}
		.title-wrap {
			margin-top: 30px;
			margin-bottom: 31px;
		}
		.title-wrap h3 {
			font-size: 30px;
		}
		.title-wrap p {
			font-size: 14px;
			line-height: 20px;
			margin-top: 24px;
		}
		.size-nation {
			font-size: 18px;
			text-align: center;
			padding-bottom: 30px;
			margin-bottom: 0;
		}
		.size-nation {
			font-size: 18px;
			text-align: center;
			padding-bottom: 30px;
			margin-bottom: 0;
		}
		.common-wrap {
			margin-top: 50px;
		    margin-bottom:40px;
		}
		
	}
</style>